import request from '@/router/axios'

/**
 * 维保计划管理 API
 */

// 分页查询（POST）
export function getMaintenancePlanPage(data) {
  return request({
    url: '/api/maintenance/plan/select/page',
    method: 'post',
    data,
  })
}

/** 供 crud-mixins：请求体使用 page/size，此处转为 current/size */
export function getList(data) {
  const body = { ...data }
  if (body.page != null && body.current == null) {
    body.current = body.page
    delete body.page
  }
  return getMaintenancePlanPage(body)
}

/** 导出 Excel（筛选条件与列表查询一致，服务端生成） */
export function exportMaintenancePlanExcel(data) {
  const body = { ...data }
  if (body.page != null && body.current == null) {
    body.current = body.page
    delete body.page
  }
  return request({
    url: '/api/maintenance/plan/export/excel',
    method: 'post',
    data: body,
    responseType: 'blob'
  })
}

export function exportDelayAuditExcel(data) {
  return request({
    url: '/api/maintenance/plan/delay-audit/export/excel',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function exportCompleteAuditExcel(data) {
  return request({
    url: '/api/maintenance/plan/complete-audit/export/excel',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 根据 ID 查询
export function getMaintenancePlanById(id) {
  return request({
    url: `/api/maintenance/plan/get/${id}`,
    method: 'get',
  })
}

// 新增
export function addMaintenancePlan(data) {
  return request({
    url: '/api/maintenance/plan/add',
    method: 'post',
    data,
  })
}

// 更新
export function updateMaintenancePlan(data) {
  return request({
    url: '/api/maintenance/plan/update',
    method: 'post',
    data,
  })
}

// 删除
export function deleteMaintenancePlan(id) {
  return request({
    url: `/api/maintenance/plan/delete/${id}`,
    method: 'get',
  })
}

// 开始维保
export function startMaintenance(id, executorId, executorName) {
  return request({
    url: '/api/maintenance/plan/start',
    method: 'post',
    data: { id, executorId, executorName },
  })
}

export const uploadEndpoint = '/produce/api/blade-resource/oss/endpoint/put-file-attach'

// 完成维保
export function completeMaintenance(id, result, remark, maintenancePhotos) {
  return request({
    url: '/api/maintenance/plan/complete',
    method: 'post',
    data: { id, result, remark, maintenancePhotos },
  })
}

// 申请延期
export function applyDelay(id, delayDate, reason) {
  return request({
    url: '/api/maintenance/plan/delay/apply',
    method: 'post',
    data: { id, delayDate, reason },
  })
}

// 审核延期申请
export function auditDelay(id, status, auditorId, auditorName, remark) {
  return request({
    url: '/api/maintenance/plan/delay/audit',
    method: 'post',
    data: { id, status, auditorId, auditorName, remark },
  })
}

// 审核维保完成
export function auditComplete(id, status, auditorId, auditorName, remark) {
  return request({
    url: '/api/maintenance/plan/complete/audit',
    method: 'post',
    data: { id, status, auditorId, auditorName, remark },
  })
}

// 生成维保计划
export function generatePlans() {
  return request({
    url: '/api/maintenance/plan/generate',
    method: 'get',
  })
}

// 统计数据
export function getStatistics() {
  return request({
    url: '/api/maintenance/plan/statistics',
    method: 'get',
  })
}

// 调度中心年度/月度统计
export function getDispatchOverview() {
  return request({
    url: '/api/maintenance/plan/dispatch/overview',
    method: 'get',
  })
}

export function getDispatchStatistics(data) {
  return request({
    url: '/api/maintenance/plan/dispatch/statistics',
    method: 'post',
    data,
  })
}

// 查询待审核列表
export function getPendingAudits(data = {}) {
  if (Object.keys(data).length === 0) {
    return request({
      url: '/api/maintenance/plan/pending/audits',
      method: 'get',
    })
  }
  return request({
    url: '/api/maintenance/plan/pending/audits',
    method: 'post',
    data,
  })
}

export function getMaintenanceConfig() {
  return request({
    url: '/api/maintenance/plan/config',
    method: 'get',
  })
}

export function saveMaintenanceConfig(maxDelayDays) {
  return request({
    url: '/api/maintenance/plan/config',
    method: 'post',
    data: { maxDelayDays },
  })
}
